export const tooltip = (
    <>
        <h4>Негабаритное отправление:</h4>
        <span>Высота от 2.1 до 2.5 м</span>
        <span>Ширина от 2 до 2.45 м</span>
        <span>Длина от 3 до 6 м</span>
        <span>Вес от 1000 до 2000 кг</span>
    </>
);
